<template>
  <StModal :on-close="() => $emit(CLOSE)">
    <div class="st-bo-block-admin-modal">
      <StHeadline :level="2">
        {{ isBlocked ? "Aktivera" : "Spärra" }} personnummer
      </StHeadline>
      <p class="st-bo-block-admin-modal__paragraph">
        {{ text }}
      </p>
      <div class="st-bo-block-admin-modal__buttons">
        <st-button
          rectangular
          secondary
          full-width
          @click="$emit(CLOSE)"
          tabindex="0"
        >
          Avbryt
        </st-button>
        <st-button
          rectangular
          full-width
          @click="$emit('block')"
          tabindex="0"
          :is-loading="isLoading"
        >
          {{ isBlocked ? "Aktivera" : "Spärra" }}
        </st-button>
      </div>
    </div>
  </StModal>
</template>

<script>
import { StModal, StButton, StHeadline } from "skanetrafiken";
import { CLOSE } from "@/constants";
export default {
  name: "st-bo-block-admin-modal",
  components: {
    StModal,
    StButton,
    StHeadline,
  },
  props: {
    text: String,
    isBlocked: Boolean,
    isLoading: Boolean,
  },
  setup() {
    return { CLOSE };
  },
};
</script>

<style lang="scss" scoped>
@import "~skanetrafiken/dist/scss/main.scss";
.st-bo-block-admin-modal {
  text-align: center;
  font-family: $source-sans-pro;
  max-width: rem-calc(600);
  &__paragraph {
    margin: rem-calc(30) 0 rem-calc(30) 0;
  }

  &__buttons {
    display: flex;

    & > :last-child {
      margin-left: rem-calc(10);
    }
  }
}
</style>
